import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { Typography } from '@material-ui/core';

import { formatPeso, disablePeso } from '../../utils';

function getDados(dados) {
  const semSaldo =
    dados.saldo_unidades_apos === null ||
    dados.saldo_unidades_apos === undefined;
  if (semSaldo) return '-';

  const unidades = `${dados.saldo_unidades_apos} Un`;
  if (!disablePeso(dados.produto)) return unidades;

  return `${unidades} / ${formatPeso(dados.saldo_peso_apos)}`;
}

const SaldoField = ({ ...props }) => {
  const record = useRecordContext(props);

  const label = record ? (record.record ? getDados(record.record) : '-') : '-';

  return (
    <div>
      <Typography variant="subtitle1">{label}</Typography>
    </div>
  );
};

export default SaldoField;
